import React from 'react';
import styles from './SellSteps.module.scss';
import { images } from '../../../../constants/images';

const SellSteps: React.FC = () => {
    return (
        <div className={styles.stepsContainer}>
            <div className={styles.step}>
                <img src={images.FigureBackground_1} alt="" className={styles.backgroundImage} />
                <span className={styles.stepNumber}>1.</span>
                <div className={styles.content}>
                    <h3>Añade los detalles de tu auto</h3>
                    <p>Cuantos más detalles, mayor será el alcance de tu publicación.</p>
                </div>
            </div>

            <div className={styles.step}>
                <img src={images.FigureBackground_2} alt="" className={styles.backgroundImage} />
                <span className={styles.stepNumber}>2.</span>
                <div className={styles.content}>
                    <h3>Prepara tus fotos</h3>
                    <p>Sube fotos del frente, atrás, laterales e interiores de tu auto. También puedes adjuntar videos</p>
                </div>
            </div>

            <div className={styles.step}>
                <img src={images.FigureBackground_1} alt="" className={styles.backgroundImage} />
                <span className={styles.stepNumber}>3.</span>
                <div className={styles.content}>
                    <h3>¡Auto publicado!</h3>
                    <p>Comienza a recibir ofertas y negociaciones para venderlo 100% digital</p>
                </div>
            </div>
        </div>
    );
};

export default SellSteps;
